import { render, staticRenderFns } from "./labsamples.vue?vue&type=template&id=21e6a468"
import script from "./labsamples.vue?vue&type=script&lang=js"
export * from "./labsamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports